<template>
  <section :class="['check', `check--${element}`]" tabindex="0">
    <!-- Input -->
    <input
      :id="id"
      v-model="model"
      :value="label"
      type="checkbox"
      name="checkbox"
      :class="[
        'check__input',
        {
          'check__input--active': active,
          'check__input--disabled': disabled,
        },
      ]"
      @input="emitModel"
    />

    <!-- Label -->
    <label :for="id" :class="['check__label']">
      {{ label }}
    </label>
  </section>
</template>

<script>
export default {
  name: 'Checkbox',

  components: {},

  props: {
    id: {
      type: Number,
      default: Number,
    },
    label: {
      type: String,
      default: String,
    },
    element: {
      type: String,
      default: 'medium',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    cards: {
      type: Array,
      required: true,
    },
    metadata: {
      type: Object,
    },
  },

  data() {
    return {
      model: this.active,
    };
  },

  // Watcher
  watch: {
    model: {
      immediate: true,
      deep: true,
      handler() {},
    },
  },

  // Methods
  methods: {
    emitModel() {
      this.model = !this.model;
      this.$emit('emit-model', {
        id: this.id,
        element: this.element,
        label: this.label,
        active: this.model,
        disabled: this.disabled,
        cards: this.cards,
        metadata: this.metadata,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.check {
  @include flexbox(flex-start, flex-start);

  &--medium {
    .check__label {
      color: #be5b92;
      &:before,
      &:after {
        border-color: #be5b92;
      }
    }
  }

  &--dark {
    .check__label {
      color: #006d8a;
      &:before,
      &:after {
        border-color: #006d8a;
      }
    }
  }

  &--light {
    .check__label {
      color: #ffce00;
      &:before,
      &:after {
        border-color: #ffce00;
      }
    }
  }

  &__label {
    color: #646464;
    transition: $transition;
    @include flexbox(center, flex-start);
    //
    font-size: rem(10);
    position: relative !important;
    word-wrap: break-word;
    cursor: pointer;
    margin: 0 !important;

    &:before {
      content: '';
      width: rem(17);
      height: rem(17);
      margin-right: rem(5);
      border: 1px solid #be5b92;
      position: absolute;
      border-radius: rem(2);
      right: 100%;
      background: $white;
      transition: $transition;
    }

    &:after {
      content: '';
      width: rem(10);
      height: rem(6);
      position: absolute;
      border: 2px solid #be5b92;
      top: rem(3);
      left: rem(-18);
      border-top: none;
      border-right: none;
      transform: rotate(-45deg);
      display: none;
      transition: $transition;

      @include iPadProStyles {
        width: rem(12);
        height: rem(8);
      }
    }

    @include iPadProStyles {
      font-size: 14px;
    }
  }

  &__input {
    visibility: hidden;
    opacity: 0;

    &--active {
      &:checked + .check__label:after {
        display: block;
      }
    }

    &--disabled {
      + .check__label {
        opacity: .5;
        cursor: not-allowed;
        pointer-events: none;
        color: #888;

        &:before {
          background: #f5f5f5;
          border-color: #c4c2c2;
        }
      }
    }
  }
}
</style>
